import axios from 'axios';

const instance = axios.create({
  //   baseURL: "http://localhost:8083/api2",
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

export default instance;
